import { Attribute } from "@angular/core";
import { DataType } from "src/app/constants/enum";

export const avmRentalConfig = {
  params: [
    {
      attribute: "lat",
      type: DataType.Number,
      label: "Latitude",
      required: true,
      description: "(number)"
    },
    {
      attribute: "lon",
      type: DataType.Number,
      label: "Longitude",
      required: true,
      description: "(number)"
    }
  ],
  filters: [
    { attribute: "unit_area", type: DataType.Number, label: "Unit Area", description: "(number)" },
    { attribute: "total_rooms", type: DataType.Number, label: "Total Rooms", description: "(Value: 1 or more)" },
    { attribute: "bathrooms", type: DataType.Number, label: "Bathrooms", description: "(Value: 1 or more)" },
    { attribute: "kitchen", type: DataType.Number, label: "Kitchen", description: "(Value: 1 or more)" },
    { attribute: "is_furnished", type: DataType.Boolean, data: [{ label: "YES", value: 1 }, { label: "NO", value: 0 }], label: "Is Furnished", description: "" },
    { attribute: "split_unit", type: DataType.Boolean, data: [{ label: "YES", value: 1 }, { label: "NO", value: 0 }], label: "Split Unit", description: "" },
    { attribute: "central_ac", type: DataType.Boolean, data: [{ label: "NO", value: 1 }, { label: "SEMI", value: 2 }, { label: "FULL", value: 3 }], label: "Central AC", description: "(1 - NO, 2 - SEMI, 3 - FULL)" },
    { attribute: "parking_available", type: DataType.Boolean, data: [{ label: "YES", value: 1 }, { label: "NO", value: 0 }], label: "Parking Available", description: "" },
    { attribute: "total_floors", type: DataType.Number, label: "Total Floors", description: "(1 or more)" },
    { attribute: "units_per_floor", type: DataType.Number, label: "Units Per Floor", description: "(1 or more)" },
    { attribute: "total_units_in_contract", type: DataType.Number, label: "Total Units In Contract", description: "(number)" },
  ],

  construction: [
    { attribute: "construction_new", value: "construction_new", label: "Construction New", description: "" },
    { attribute: "construction_medium", value: "construction_medium", label: "Construction Medium", description: "" },
    { attribute: "construction_old", value: "construction_old", label: "Construction Old", description: "" },
  ],
  units: [
    { attribute: "apartment_unit", value: "apartment_unit", label: "Apartment Unit", description: "" },
    { attribute: "duplex_unit", value: "duplex_unit", label: "Duplex Unit", description: "" },
    { attribute: "floor_unit", value: "floor_unit", label: "Floor Unit", description: "" },
    { attribute: "rooftop_apartment_unit", value: "rooftop_apartment_unit", label: "Rooftop Apartment Unit", description: "" },
    { attribute: "rooftop_floor_unit", value: "rooftop_floor_unit", label: "Rooftop Floor Unit", description: "" },
    { attribute: "secondary_apartment_unit", value: "secondary_apartment_unit", label: "Secondary Apartment Unit", description: "" },
    { attribute: "studio_unit", value: "studio_unit", label: "Studio Unit", description: "" },
    { attribute: "villa_unit", value: "villa_unit", label: "Villa Unit", description: "" },
    { attribute: "floor_extension_unit", value: "floor_extension_unit", label: "Floor Extension Unit", description: "" },
    { attribute: "penthouse_villa_unit", value: "penthouse_villa_unit", label: "Penthouse Villa Unit", description: "" },
    { attribute: "apartment_extension_unit", value: "apartment_extension_unit", label: "Apartment Extention Unit", description: "" },

  ],
  property: [
    { attribute: "property_building", value: 'property_building', label: "Property Building", description: "" },
    { attribute: "property_villa", value: 'property_villa', label: "Property Villa", description: "" },
    { attribute: "property_other", value: 'property_other', label: "Property Other", description: "e" },
    { attribute: "property_rest_house", value: 'property_rest_house', label: "Property Rest House", description: "" },
    { attribute: "property_farm", value: 'property_farm', label: "Property Farm", description: "" },
    { attribute: "property_tower", value: 'property_tower', label: "Property Tower", description: "" },
    { attribute: "property_plaza", value: 'property_plaza', label: "Property Plaza", description: "" }
  ],
};

export const commercialRentalConfig = {
  params: [
    {
      attribute: "lat",
      type: DataType.Number,
      label: "Latitude",
      required: true,
      description: "(number)"
    },
    {
      attribute: "lon",
      type: DataType.Number,
      label: "Longitude",
      required: true,
      description: "(number)"
    }
  ],
  filters: [
    { attribute: "unit_area", type: DataType.Number, label: "Unit Area", description: "" },
    { attribute: "units_per_floor", type: DataType.Number, label: "Units Per Floor", description: "" },
    { attribute: "is_furnished", type: DataType.Boolean, data: [{ label: "YES", value: 1 }, { label: "NO", value: 0 }], label: "Is Furnished", description: "" },
    { attribute: "central_ac", type: DataType.Boolean, data: [{ label: "NO", value: 1 }, { label: "SEMI", value: 2 }, { label: "FULL", value: 3 }], label: "Central AC", description: "(1 - NO, 2 - SEMI, 3 - FULL)" },
    { attribute: "split_unit", type: DataType.Boolean, data: [{ label: "YES", value: 1 }, { label: "NO", value: 0 }], label: "Split Unit", description: "" },
    { attribute: "total_units_in_contract", type: DataType.Number, label: "Total Units In Contract", description: "" },
    { attribute: "parking_available", type: DataType.Boolean, data: [{ label: "YES", value: 1 }, { label: "NO", value: 0 }], label: "Parking Available", description: "" },
    { attribute: "include_mezzanine", data: [{ label: "YES", value: 1 }, { label: "NO", value: 0 }], type: DataType.Boolean, label: "Include Mezzanine ", description: "" },
    { attribute: "elevators", type: DataType.Number, label: "Elevators", description: "" },
    { attribute: "security_entries", type: DataType.Number, label: "Security Entries", description: "" },
    { attribute: "total_floors_in_property", type: DataType.Number, label: "Total Floors In Property", description: "" },
  ],
  property: [
    { attribute: "property_closed_retail_mall", value: 'property_closed_retail_mall', label: "Closed Retail Mall", description: "" },
    { attribute: "property_multistory_building", value: 'property_multistory_building', label: "Multistory Building", description: "" },
    { attribute: "property_other", value: 'property_other', label: "Other", description: "e" },
    { attribute: "property_open_retail", value: 'property_open_retail', label: "Open Retail", description: "" },
    { attribute: "property_land", value: 'property_land', label: "Land", description: "" },
    { attribute: "property_tower", value: 'property_tower', label: "Tower", description: "" },
    { attribute: "property_factory", value: 'property_factory', label: "Factory", description: "" },
    { attribute: "property_farm", value: 'property_farm', label: "Farm", description: "" },
    { attribute: "property_vacation_house", value: 'property_vacation_house', label: "Vacation House", description: "" },
    { attribute: "property_villa", value: "property_villa", label: "Villa", description: "" },
    { attribute: "is_compound_property_part", value: "is_compound_property_part", label: "Is Compound Property Part", description: "" },
  ],
  units: [
    { attribute: "unit_exhibtion", value: 'unit_exhibtion', label: "Exhibtion", description: "" },
    { attribute: "unit_office", value: 'unit_office', label: "Office", description: "" },
    { attribute: "unit_shop", value: 'unit_shop', label: "Shop", description: "" }
  ],
  finishType: [
    { attribute: "UnitFinishing_eng_unknown", value: 'UnitFinishing_eng_unknown', label: "Unknown", description: "" },
    { attribute: "unit_finishing_finished", value: 'unit_finishing_finished', label: "Finished", description: "" },
    { attribute: "unit_finishing_unfinished", value: 'unit_finishing_unfinished', label: "Unfinished", description: "" },
    { attribute: "unit_finishing_structure", value: 'unit_finishing_structure', label: "Structure", description: "" },
  ]
};

export const apartmentSaleAvmConfig = {
  params: [
    {
      attribute: "lat",
      type: DataType.Number,
      label: "Latitude",
      required: true,
      description: "(number)"
    },
    {
      attribute: "lon",
      type: DataType.Number,
      label: "Longitude",
      required: true,
      description: "(number)"
    }
  ],
  filters: [
    { attribute: "unit_area", type: DataType.Number, label: "Unit Area", description: "(number)" },
    { attribute: "total_rooms", type: DataType.Number, label: "Total Rooms", description: "(Value: 1 or more)" },
    { attribute: "bathrooms", type: DataType.Number, label: "Bathrooms", description: "(Value: 1 or more)" },
    { attribute: "kitchen", type: DataType.Number, label: "Kitchen", description: "(Value: 1 or more)" },
    { attribute: "is_furnished", type: DataType.Boolean, data: [{ label: "YES", value: 1 }, { label: "NO", value: 0 }], label: "Is Furnished", description: "" },
    { attribute: "split_unit", type: DataType.Boolean, data: [{ label: "YES", value: 1 }, { label: "NO", value: 0 }], label: "Split Unit", description: "" },
    { attribute: "central_ac", type: DataType.Boolean, data: [{ label: "NO", value: 1 }, { label: "SEMI", value: 2 }, { label: "FULL", value: 3 }], label: "Central AC", description: "(1 - NO, 2 - SEMI, 3 - FULL)" },
    { attribute: "parking_available", type: DataType.Boolean, data: [{ label: "YES", value: 1 }, { label: "NO", value: 0 }], label: "Parking Available", description: "" },
    { attribute: "total_floors", type: DataType.Number, label: "Total Floors", description: "(1 or more)" },
    { attribute: "units_per_floor", type: DataType.Number, label: "Units Per Floor", description: "(1 or more)" },
    { attribute: "total_units_in_contract", type: DataType.Number, label: "Total Units In Contract", description: "(number)" },
  ],

  construction: [
    { attribute: "construction_new", value: "construction_new", label: "Construction New", description: "" },
    { attribute: "construction_medium", value: "construction_medium", label: "Construction Medium", description: "" },
    { attribute: "construction_old", value: "construction_old", label: "Construction Old", description: "" },
  ],
  units: [
    { attribute: "apartment_unit", value: "apartment_unit", label: "Apartment Unit", description: "" },
    { attribute: "duplex_unit", value: "duplex_unit", label: "Duplex Unit", description: "" },
    { attribute: "floor_unit", value: "floor_unit", label: "Floor Unit", description: "" },
    { attribute: "rooftop_apartment_unit", value: "rooftop_apartment_unit", label: "Rooftop Apartment Unit", description: "" },
    { attribute: "rooftop_floor_unit", value: "rooftop_floor_unit", label: "Rooftop Floor Unit", description: "" },
    { attribute: "secondary_apartment_unit", value: "secondary_apartment_unit", label: "Secondary Apartment Unit", description: "" },
    { attribute: "studio_unit", value: "studio_unit", label: "Studio Unit", description: "" },
    { attribute: "villa_unit", value: "villa_unit", label: "Villa Unit", description: "" },
  ],
  property: [
    { attribute: "property_building", value: 'property_building', label: "Property Building", description: "" },
    { attribute: "property_villa", value: 'property_villa', label: "Property Villa", description: "" },
    { attribute: "property_other", value: 'property_other', label: "Property Other", description: "" }
  ]
};



export const AvmApiConfig = {
  params: [
    {
      attribute: "land_area",
      type: DataType.String,
      label: "Land Area",
      required: false,
      description: ""
    },
    {
      attribute: "parcel_uid",
      type: DataType.String,
      label: "Parcel Uid",
      required: false,
      description: "(Either property_uid or parcel_uid is mandatory)"
    },
    {
      attribute: "property_uid",
      type: DataType.String,
      label: "Property Uid",
      required: false,
      description: "(Either property_uid or parcel_uid is mandatory)"
    }
  ]
}
export const NearbyApiDataConfig = {
  params: [
    {
      attribute: "lat",
      type: DataType.Number,
      label: "Latitude",
      required: true,
      description: "(number)"
    },
    {
      attribute: "lon",
      type: DataType.Number,
      label: "Longitude",
      required: true,
      description: "(number)"
    },
    {
      attribute: "distance",
      type: DataType.String,
      label: " Distance",
      required: true,
      description: "(meter)"
    },
     {
      attribute: "limit",
      type: DataType.Number,
      label: "limit",
      required: false,
      description: "(number) Not more than 100",
      default: 20
    },
    {
      attribute: "offset",
      type: DataType.Number,
      label: "Offset",
      required: false,
      description: "(number)"
    }
  ],
  filters: [
    {
      attribute: "category", type: DataType.Boolean, label: "Category", required: true, data:
        [{ label: "All Services", value: "All Services" }, { label: "Healthcare", value: 'Healthcare' },
        { label: "Education", value: "Education" }, { label: "Religious", value: "Religious" },], description: ""
    }
  ]
}

export const AvmDataConfig = {
  params: [
    {
      attribute: "lat",
      type: DataType.Number,
      label: "Latitude",
      required: true,
      description: "(number)"
    },
    {
      attribute: "lon",
      type: DataType.Number,
      label: "Longitude",
      required: true,
      description: "(number)"
    },
    {
      attribute: "land_area",
      type: DataType.String,
      label: "Land Area",
      required: false,
      description: ""
    }
  ],
  // filters: [
  //   { attribute: "parcel_uid", type: DataType.String, label: "Parcel UID", description: "" },
  //   { attribute: "property_uid", type: DataType.String, label: "Property UID", description: "" }
  // ]
}


export const NearByDataConfig = {
  params: [
    {
      attribute: "lat",
      type: DataType.Number,
      label: "Latitude",
      required: true,
      description: "(number)"
    },
    {
      attribute: "lon",
      type: DataType.Number,
      label: "Longitude",
      required: true,
      description: "(number)"
    }
  ]
}
export const BuildingsConfig = {
  params: [
    {
      attribute: "lat",
      type: DataType.Number,
      label: "Latitude",
      required: false,
      description: "(number)"
    },
    {
      attribute: "lon",
      type: DataType.Number,
      label: "Longitude",
      required: false,
      description: "(number)"
    },
    {
      attribute: "limit",
      type: DataType.Number,
      label: "limit",
      required: false,
      description: "(number) Not more than 100",
      default: 100
    },
    {
      attribute: "offset",
      type: DataType.Number,
      label: "Offset",
      required: false,
      description: "(number)"
    }
  ],
  filters: [
    { attribute: "neigh_name", type: DataType.String, label: "Neigh Name", description: "" },
    { attribute: "property_cat_subcat", type: DataType.String, label: "Property Cat Subcat", description: "" },
    { attribute: "property_sub_cat", type: DataType.String, label: "Property Subcat", description: "" },
    { attribute: "property_uid", type: DataType.String, label: "Property UID", description: "" },
    { attribute: "property_name", type: DataType.String, label: "Property Name", description: "" },
    { attribute: "property_grade", type: DataType.String, label: "Property Grade", description: "" },
     { attribute: "parcel_uid", type: DataType.String, label: "Parcel UID", description: "" },
    { attribute: "paci_no", type: DataType.String, label: "Paci No", description: "" }
  ]
};

export const FloorsConfig = {
  params: [
    {
      attribute: "limit",
      type: DataType.Number,
      label: "Limit",
      required: false,
      description: "(number) Not more than 100",
      default: 100
    },
    {
      attribute: "offset",
      type: DataType.Number,
      label: "Offset",
      required: false,
      description: "(number)",
      default: 0
    }
  ],
  filters: [
    { attribute: "property_uid", type: DataType.String, label: "Property UID", description: "" },
    { attribute: "floor_uid", type: DataType.String, label: "Floor UID", description: "" },
    { attribute: "floor_number", type: DataType.Number, label: "floor Number", description: "" }
  ]
};


export const UnitsConfig = {
  params: [
    {
      attribute: "limit",
      type: DataType.Number,
      label: "limit",
      required: false,
      description: "(number) Not more than 100",
      default: 100
    },
    {
      attribute: "offset",
      type: DataType.Number,
      label: "Offset",
      required: false,
      description: "(number)",
      default: 0
    }
  ],
  filters: [
    { attribute: "property_uid", type: DataType.String, label: "Property UID", description: "" },
    { attribute: "floor_uid", type: DataType.String, label: "Floor Uid", description: "" },
    { attribute: "unit_uid", type: DataType.String, label: "Unit Uid", description: "" },
    { attribute: "unit_type", type: DataType.String, label: "Unit Type", description: "" },
    { attribute: "unit_sub_type", type: DataType.String, label: "Unit Sub Type", description: "" },
    { attribute: "category", type: DataType.String, label: "Category", description: "" },
    { attribute: "shop_name", type: DataType.String, label: "Shop Name", description: "" },
    { attribute: "unit_number", type: DataType.Number, label: "Unit Number", description: "(e.g. 50)" },
    { attribute: "unit_area", type: DataType.String, label: "Unit Area", description: "(e.g. 50-100)" }
  ]
};



export const TransactionsConfig = {
  params: [
    {
      attribute: "limit",
      type: DataType.Number,
      label: "limit",
      required: false,
      description: "(number) Not more than 100",
      default: 100
    },
    {
      attribute: "offset",
      type: DataType.Number,
      label: "Offset",
      required: false,
      description: "(number)",
      default: 0
    },
    { attribute: "property_uid", type: DataType.String, label: "Property UID", description: "" },
    { attribute: "unit_uid", type: DataType.String, label: "Unit UID", description: "" },
    { attribute: "transaction_uid", type: DataType.String, label: "Transaction UID", description: "" },
    { attribute: "entity_type", type: DataType.String, label: "Entity Type", description: "" },
    { attribute: "outlier", type: DataType.Boolean, label: "Outlier", data: [{ label: "TRUE", value: true }, { label: "FALSE", value: false }], description: "" },
    { attribute: "transaction_value", type: DataType.String, label: "Transaction Value", description: "(e.g. 100-200)" },
    { attribute: "transaction_area", type: DataType.String, label: "Transaction Area", description: "(e.g. 50-100)" },
    { attribute: "date", type: DataType.DateRange, label: "Transaction Date", description: "(This filter will be used to apply for transaction sale  date filter)" },
    { attribute: "transaction_date", type: DataType.DateRange, label: "Rental Date", description: "(This filter will be used to apply rental start date and end date filter. Values like '2025-09-16 to 2025-09-18')" }
  ],

};